module.exports = __webpack_public_path__ + "static/media/helengeli-39.72bdd235.jpg";